import type { RouteObject } from 'react-router'
import type { WaitForAuthResolutionFn } from '@/features/iam'
import type { LegendsFeature } from '@/features/legends'
import {
  createLegendEditorViewLoader,
  createLegendListViewLoader,
} from '@/features/legends/legend-route-loaders'
import { isRefreshDesign } from '@/infra/design'

const importLegendEditor = () =>
  import('@/features/legends/LegendEditor/LegendEditorContainer')

/**
 * Options for {@link createRoutes}.
 */
export interface CreateLegendsRoutesOptions {
  legends: LegendsFeature
  waitForAuthResolution: WaitForAuthResolutionFn
}

/**
 * Creates routes for the legends feature. The legend builder only exists in
 * the refreshed design.
 */
export function createRoutes(
  options: CreateLegendsRoutesOptions,
): RouteObject[] {
  if (!isRefreshDesign) {
    return []
  }

  return [
    {
      path: '/legends',
      loader: createLegendListViewLoader(options),
      lazy: {
        Component: () => {
          // Load the editor's code too, so opening a legend doesn't wait for it.
          void importLegendEditor()
          return import('@/features/legends/LegendList/LegendListContainer').then(
            (r) => r.default,
          )
        },
      },
    },
    {
      path: '/legends/:legendId/:tab?',
      loader: createLegendEditorViewLoader(options),
      lazy: {
        Component: () => importLegendEditor().then((r) => r.default),
      },
    },
  ]
}
